'use strict';

var series = require('async/series');

var Bitswap = require('ipfs-bitswap');

var setImmediate = require('async/setImmediate');

var promisify = require('promisify-es6');

module.exports = function (self) {
  return promisify(function (callback) {
    var done = function done(err) {
      if (err) {
        setImmediate(function () {
          return self.emit('error', err);
        });
        return callback(err);
      }

      self.state.started();
      setImmediate(function () {
        return self.emit('start');
      });
      callback();
    };

    if (self.state.state() !== 'stopped') {
      return done(new Error("Not able to start from state: ".concat(self.state.state())));
    }

    self.log('starting');
    self.state.start();
    series([function (cb) {
      // The repo may be closed if previously stopped
      self._repo.closed ? self._repo.open(cb) : cb();
    }, function (cb) {
      return self.libp2p.start(cb);
    }, function (cb) {
      self._bitswap = new Bitswap(self._libp2pNode, self._repo.blocks, {
        statsEnabled: true
      });

      self._bitswap.start();

      self._blockService.setExchange(self._bitswap);

      self._preload.start();

      self._ipns.republisher.start();

      self._mfsPreload.start(cb);
    }], done);
  });
};